import { comporCatalogoMotivoPadrao } from './composicao/modulos/motivo-padrao.composicao'
import { comporCatalogoRegraDeCalculo } from './composicao/modulos/regra-de-calculo.composicao'
import { comporCatalogoUsuario } from './composicao/modulos/usuario.composicao'
import { comporCatalogoPerfilDePermissao } from './composicao/modulos/perfil-de-permissao.composicao'
import { comporCatalogoGrupoDeLocaisDeTrabalho } from './composicao/modulos/grupo-de-locais-de-trabalho.composicao'
import type { App } from 'vue'
import { VueQueryPlugin } from '@tanstack/vue-query'
import {
  CHAVE_CATALOGOS_PERSISTIDOS,
  usarContextoCatalogo,
} from '@next/compartilhados/catalogos'

import {
  criarTarefasAquecimentoCatalogos,
  iniciarAquecimentoCatalogos,
} from './composicao/aquecimento-catalogos'
import { criarInfraestrutura } from './composicao/criar-infraestrutura'
import { criarQueryClient } from './composicao/criar-query-client'
import { comporCatalogoEmpregador } from './composicao/modulos/empregador.composicao'
import { comporCatalogoEmpregado } from './composicao/modulos/empregado.composicao'
import { comporCatalogoLocalDeTrabalho } from './composicao/modulos/local-de-trabalho.composicao'
import { instalarModulos } from './composicao/instalar-modulos'
import type { DependenciasSrcNext } from './dependencias-src-next'

export const instalarSrcNext = (
  app: App,
  dependencias: DependenciasSrcNext,
) => {
  const infraestrutura = criarInfraestrutura(dependencias)
  const queryClient = criarQueryClient()

  app.use(VueQueryPlugin, { queryClient })

  app.provide(
    CHAVE_CATALOGOS_PERSISTIDOS,
    infraestrutura.catalogosPersistidos,
  )
  instalarModulos(app, infraestrutura)

  const contextoCatalogo = app.runWithContext(usarContextoCatalogo)
  const pararAquecimento = iniciarAquecimentoCatalogos(
    contextoCatalogo,
    criarTarefasAquecimentoCatalogos(queryClient, infraestrutura, contextoCatalogo),
  )
  app.onUnmount(pararAquecimento)
  return {
    queryClient,
    catalogosPersistidos: infraestrutura.catalogosPersistidos,
    contexto: contextoCatalogo,
    consultar: comporCatalogoLocalDeTrabalho(infraestrutura).listarOpcoes,
    consultarEmpregados: comporCatalogoEmpregado(infraestrutura).listarOpcoes,
    consultarGrupos: comporCatalogoGrupoDeLocaisDeTrabalho(infraestrutura).listarOpcoes,
    consultarPerfis: comporCatalogoPerfilDePermissao(infraestrutura).listarOpcoes,
    consultarUsuarios: comporCatalogoUsuario(infraestrutura).listarOpcoes,
    consultarMotivosPadrao: comporCatalogoMotivoPadrao(infraestrutura).listarOpcoes,
    consultarRegrasDeCalculo: comporCatalogoRegraDeCalculo(infraestrutura).listarOpcoes,
    consultarEmpregadores: comporCatalogoEmpregador(infraestrutura).listarOpcoes,
  }
}
